import { getFullUrl } from 'hubspot-url-utils';
import { BaseApp } from 'marketplace-storefront-base/containers/BaseApp';
import { getPublicRootUrl, getShortlinkUrl } from 'marketplace-storefront-base/utils/urls';
import MarketingNav from 'marketplace-ui-common/components/MarketingNav';
import { useEffect, useMemo, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
function getLoginUrl(location) {
  const {
    pathname,
    search
  } = location;
  return `${getFullUrl('app')}${getShortlinkUrl()}${pathname}${search}`;
}
export function PublicApp({
  history
}) {
  const [location, setLocation] = useState(history.location);
  const marketingNavLocation = useMemo(() => ({
    pathname: `${getPublicRootUrl()}${location.pathname}`,
    search: location.search
  }), [location.pathname, location.search]);
  useEffect(() => {
    const unlisten = history.listen(nextLocation => {
      setLocation(nextLocation);
    });
    return () => {
      unlisten();
    };
  }, [history]);
  return /*#__PURE__*/_jsx(MarketingNav, {
    location: marketingNavLocation,
    loginUrl: getLoginUrl(location),
    children: /*#__PURE__*/_jsx(BaseApp, {
      appContext: "public",
      history: history
    })
  });
}